import React, { useEffect, useState } from "react";
import YhInput from "../../../../../ui/YhInput";
import YhButton from "../../../../../ui/YhButton";
import { uploadThumbnailFileAmazonS3 } from "../../../../../service/aws/awService";
import {
  ImageUpLoad,
  addUserDoc,
  getUserDoc,
} from "./EmployeeDocumentServices";
import {
  isTruthy,
  openErrorNotification,
  openSuccessNotification,
} from "../../../../../helpers/methods";
import notifiers from "../../../../../global/constants/NotificationConstants";
import customErrorHandler from "../../../../../utils/customErrorHandler";

interface CustomProps {
  nextStep?: () => void | undefined;
  backStep?: () => void | undefined;
  fromSettingOrLogout?: any;
  userId: String;
  registerStepActions?: (actions: { submit: () => void | Promise<void> }) => void;
  hideFooterButtons?: boolean;
}

const EmployeeDocuments = (props: CustomProps) => {
  const [documentUserId, setDocumentUserID] = useState("");
  const [getDocumentInfo, setGetDocumentInfo] = useState<any>({});
  const [fileUrls, setFileUrls] = useState<any>({
    userId: "",
    aadhar: "",
    VoterIDCard: "",
    pan: "",
    passport: "",
    OtherDocument: "",
  });

  console.log("getDocumentInfo", fileUrls);

  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    if (props.userId) {
      try {
        const response = await getUserDoc(props.userId);
        // No docs yet is a normal empty state — do not toast / throw
        if (!response?.success || !response?.data) {
          setGetDocumentInfo({});
          return;
        }
        setGetDocumentInfo(response.data);
        setFileUrls((prev: any) => ({
          ...prev,
          ...response.data,
          userId: props.userId,
        }));
      } catch (error: any) {
        const msg = String(error?.message || "");
        if (/not been uploaded/i.test(msg) || /not found/i.test(msg)) {
          setGetDocumentInfo({});
          return;
        }
        openErrorNotification(
          isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
        );
      }
    }
  };

  // submit method
  const submitForm = async () => {
    console.log("fileUrlsssssss", fileUrls,props);
    const body = {
      userId: props.userId,
      aadhar: fileUrls.aadhar || "",
      pan: fileUrls.pan || "",
      passport: fileUrls.passport || "",
      medical: fileUrls.medical || "",
      voterId: fileUrls.voterId || "",
      others: fileUrls.others || "",
    };
    if (body.aadhar != "" || body.medical != "" || body.others != "" || body.pan != "" || body.passport != "" || body.voterId != "") {
      try {
        const response = await addUserDoc(body);
        customErrorHandler(response);
        openSuccessNotification(response?.message);
        setDocumentUserID(response?.data?._id);
        props.nextStep?.();
        console.log("response", response);
      } catch (error: any) {
        openErrorNotification(
          isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
        );
      }
    } 
    else {
      props.nextStep?.();
    }
  };

  useEffect(() => {
    props.registerStepActions?.({ submit: submitForm });
  });

  const handleBackBtn = () => {
    props.backStep?.();
  };

  const handleFileInputChange = async (file: any | null, label: string) => {
    const data = new FormData();
    const fileImagePath = file;
    data.append("file", fileImagePath);
    if (data) {
      try {
        const uploadedUrl = await ImageUpLoad(data); // Assuming this function uploads the file to S3 and returns the URL
        console.log("uploadedUrl", uploadedUrl);
        setFileUrls((prevUrls: any) => ({
          ...prevUrls,
          [label]: uploadedUrl?.imageUrl,
        }));
      } catch (error: any) {
        openErrorNotification(
          isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
        );
      }
    }
  };

  const renderDocPreview = (url: string) => (
    <div className="mt-2">
      <a href={url} target="_blank" rel="noopener noreferrer">
        <img
          src={url}
          alt=""
          width={150}
          height={100}
          className="block"
        />
      </a>
    </div>
  );

  return (
    <div className="w-full">
      <div className="mb-5">
        <h2 className="text-lg font-semibold text-[#111827]">Employee Documents</h2>
        <p className="mt-1 text-sm text-[#6B7280]">
          Update your documents for the platform
        </p>
      </div>

      <div className="mb-6 mt-5">
        <h3 className="text-base font-semibold text-[#111827]">Documents</h3>
        <p className="mt-1 text-sm text-[#6B7280]">
          {props.fromSettingOrLogout === "fromSettingOrLogout"
            ? "Manage your documents"
            : "Manage documents"}
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <div>
          <YhInput
            label="Adhaar Card"
            type="file"
            onChange={(e: any) =>
              handleFileInputChange(e.target.files[0], "aadhar")
            }
          />
          {getDocumentInfo && getDocumentInfo.aadhar && getDocumentInfo.aadhar != "" &&
            renderDocPreview(getDocumentInfo.aadhar)}
        </div>

        <div>
          <YhInput
            label="PAN Card"
            type="file"
            onChange={(e: any) =>
              handleFileInputChange(e.target.files[0], "pan")
            }
          />
          {getDocumentInfo && getDocumentInfo.pan && getDocumentInfo.pan != "" &&
            renderDocPreview(getDocumentInfo.pan)}
        </div>

        <div>
          <YhInput
            label="Passport"
            type="file"
            onChange={(e: any) =>
              handleFileInputChange(e.target.files[0], "passport")
            }
          />
          {getDocumentInfo && getDocumentInfo.passport && getDocumentInfo.passport != "" &&
            renderDocPreview(getDocumentInfo.passport)}
        </div>

        <div>
          <YhInput
            label="Medical Card"
            type="file"
            onChange={(e: any) =>
              handleFileInputChange(e.target.files[0], "medical")
            }
          />
          {getDocumentInfo && getDocumentInfo.medical && getDocumentInfo.medical != "" &&
            renderDocPreview(getDocumentInfo.medical)}
        </div>

        <div>
          <YhInput
            label="Voter ID Card"
            type="file"
            onChange={(e: any) =>
              handleFileInputChange(e.target.files[0], "voterId")
            }
          />
          {getDocumentInfo && getDocumentInfo.voterId && getDocumentInfo.voterId != "" &&
            renderDocPreview(getDocumentInfo.voterId)}
        </div>

        <div>
          <YhInput
            label="Other Document"
            type="file"
            onChange={(e: any) =>
              handleFileInputChange(e.target.files[0], "others")
            }
          />
          {getDocumentInfo && getDocumentInfo.others && getDocumentInfo.others != "" &&
            renderDocPreview(getDocumentInfo.others)}
        </div>

        <div className="mt-2 flex flex-wrap gap-3 lg:col-span-2">
          {props.hideFooterButtons ? null : (
            <>
              <YhButton variant="secondary" onClick={handleBackBtn}>
                Back
              </YhButton>
              <YhButton variant="primary" onClick={submitForm}>
                Save & Continue
              </YhButton>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmployeeDocuments;
